export const ReceiveNotificationsTotalToUser_Message =
  "ReceiveNotificationsTotalToUser";
export const ReceiveCarriersNotificationUpdate_Message =
  "ReceiveCarriersNotificationUpdate";
export const ReceiveCapacityNotificationUpdate_Message =
  "ReceiveCapacityNotificationUpdate";
export const ReceiveFiltersAssignmentUpdate_Message =
  "ReceiveFiltersAssignmentUpdate";
